export const TUVIS_MESSAGE_SOURCES = [
  "desktop",
  "sidecar",
  "extension",
  "slack",
  "tuvisTeamsApp",
  "wabaWeb",
  "archive",
  "tuvisBrowser",
  "tuvis_messaging",
] as const;
export type TuvisMessageSource = (typeof TUVIS_MESSAGE_SOURCES)[number];
